import { Anchor, Container, Group, Stack, Text } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function MarketingFooter() {
  const { t } = useTranslation();

  return (
    <footer
      style={{
        background: "var(--mantine-color-charcoal-8)",
        borderTop: "1px solid var(--mantine-color-charcoal-7)",
        marginTop: "auto",
      }}
    >
      <Container size="lg" py="xl">
        <Stack gap="md">
          <Group justify="space-between" align="flex-start" wrap="wrap" gap="lg">
            <div>
              <Text
                fw={700}
                size="lg"
                style={{ fontFamily: "var(--mantine-font-family-headings)" }}
              >
                <Text span c="gray.3">
                  Din
                </Text>
                <Text span c="brand.5">
                  Label
                </Text>
              </Text>
              <Text size="sm" c="dimmed" maw={280} mt={4}>
                {t("footer.tagline")}
              </Text>
            </div>

            <Group gap="xl" wrap="wrap">
              <Anchor component={Link} to="/install" c="gray.4" size="sm" underline="hover">
                {t("nav.download")}
              </Anchor>
              <Anchor component={Link} to="/buy" c="gray.4" size="sm" underline="hover">
                {t("nav.buy")}
              </Anchor>
              <Anchor component={Link} to="/tutorials" c="gray.4" size="sm" underline="hover">
                {t("nav.tutorials")}
              </Anchor>
              <Anchor href="mailto:support@dinlabel.com" c="gray.4" size="sm" underline="hover">
                {t("nav.contact")}
              </Anchor>
              <Anchor component={Link} to="/privacy" c="gray.4" size="sm" underline="hover">
                {t("footer.privacy")}
              </Anchor>
            </Group>
          </Group>

          <Text size="xs" c="dimmed">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </Text>
        </Stack>
      </Container>
    </footer>
  );
}
